var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100vw","height":"48px","color":"white","background-color":"#00a0e9","font-size":".75rem !important","display":"flex","align-items":"center","justify-content":"center"}},[_vm._v(" Copyright © Department of Interdisciplinary Engineering, School of Engineering, Kyushu University All Right Reserved. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }